module.exports = __webpack_public_path__ + "static/media/cowImage.9980c528.jpg";